import React, { useMemo, useState } from 'react';
import { Provider, ReportPeriod } from './context';
import { useLocalStorage } from '../../../hooks/useLocalStorageNew';

export const GridContextProvider = ({ children }: { children?: React.ReactNode }) => {
    const [cellsWithError, setCellsWithError] = useState<string[]>([]);
    const [selectedTimePeriod, setSelectedTimePeriod] = useState<ReportPeriod | null>(null);
    const [splitBarPos, setSplitBarPos] = useLocalStorage<number>('time_rowHeaderWidth', 400);
    const [latestModifiedDelegateUserIds, setLatestModifiedDelegateUserIds] = useLocalStorage<string[]>('time_latestModifiedDelegateUserIds', []);
    const [plannedActive, setPlannedActive] = useLocalStorage<boolean>('time_plannedActive', false);
    const [actualActive, setActualActive] = useLocalStorage<boolean>('time_actualActive', false);
    const [remainingActive, setRemainingActive] = useLocalStorage<boolean>('time_remainingActive', false);
    const value = useMemo(
        () => ({
            cellsWithError,
            setCellsWithError,
            selectedTimePeriod,
            setSelectedTimePeriod,
            splitBarPos,
            setSplitBarPos,
            latestModifiedDelegateUserIds,
            setLatestModifiedDelegateUserIds,
            plannedActive,
            setPlannedActive,
            actualActive,
            setActualActive,
            remainingActive,
            setRemainingActive,
        }),
        [
            actualActive,
            cellsWithError,
            latestModifiedDelegateUserIds,
            plannedActive,
            remainingActive,
            selectedTimePeriod,
            setActualActive,
            setLatestModifiedDelegateUserIds,
            setPlannedActive,
            setRemainingActive,
            setSplitBarPos,
            splitBarPos,
        ],
    );
    return <Provider value={value}>{children}</Provider>;
};
